module.exports = __webpack_public_path__ + "static/media/homepage_hover.9ad5f8a4.png";